<template>
  <div class="today-call">
    <FilterHeader
      @search="search"
      @refresh="refresh"
    >
      <div class="call-pop-screen-filter-options">
        <div
          :class="['filter-option', { active: reqParam.is_ticket_submitted === undefined }]"
          @click="changeFilter()"
        >{{ $t('callPopScreen.allTickets') }}</div>
        <div
          :class="['filter-option', { active: reqParam.is_ticket_submitted === 1 }]"
          @click="changeFilter(1)"
        >{{ $t('callPopScreen.ticketRecorded') }}</div>
        <div
          :class="['filter-option', { active: reqParam.is_ticket_submitted === 0 }]"
          @click="changeFilter(0)"
        >{{ $t('callPopScreen.ticketUnrecorded') }}</div>
      </div>
    </FilterHeader>
    <div class="call-list">
      <template v-if="isFinished && comCallList.length === 0">
        <div class="view-more">
          <div class="view-more-btn">{{ $t('callPopScreen.noRecords') }}</div>
        </div>
      </template>
      <template v-else>
        <CallInfoItem
          v-for="(item) in comCallList"
          :key="item.id"
          :item="item"
          listType="todayCall"
          @switchclient="onSwitchClient"
          :fieldMap="{
            cleId: 'cle_id',
            clePhone: 'cus_phone'
          }"
        />
        <div class="view-more">
          <div v-if="!isFinished" class="view-more-btn" @click="loadMore">{{isLoading ? $t('common.loading') : $t('callPopScreen.viewMore')}}</div>
          <div v-else class="view-more-btn">{{ $t('callPopScreen.noMore') }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getCdrList } from "@/api/ektv3";
import { mapGetters } from 'vuex';
import CallInfoItem from '../callInfoItem/index'
import FilterHeader from '../filterHeader'
import dayjs from 'dayjs';
import { getShortId } from '@/utils'
export default {
  props: {

  },
  data() {
    return {
      callList: [],
      callRecordCallId: '', // 记录前端保存的通话记录的call_id，筛选或刷新之后从此call_id之后的数据开始显示
      isInit: false, // 是否已经初始化
      isFinished: false,
      isLoading: false,
      isRefreshing: false, // 是否正在刷新
      reqParam: {},
      reqId: '',
      commingCall: null // 当前正在进行的通话
    }
  },
  components: {
    CallInfoItem,
    FilterHeader
  },
  computed: {
    ...mapGetters(["userInfo", 'callRecords', 'todayCallCustomers']),
    newCurCall() {
      return this.curCall()
    },
    comCallList() {
      const ret = this.callList.map(v => ({...v}))
      let records = [...this.callRecords]
      const index = records.findIndex(v => v.call_id === this.callRecordCallId)
      if(index !== -1) records = records.slice(0, index)
      records.reverse()
      records.forEach((call) => {
        const index = ret.findIndex((item) => item.call_id === call.call_id)
        if(index === -1) {
          ret.unshift({...call})
        } else {
          ret[index] = {
            ...call,
            ...ret[index]
          }
        }
      })
      if(!this.isInit || this.isRefreshing) return []
      // 获取第三方客户信息
      if(location.hash.includes('qidian/agent') || location.hash.includes('qidian/admin')) {
        const curDate = dayjs().format('YYYY-MM-DD')
        const customers = this.todayCallCustomers[curDate]
        if(customers) {
          ret.forEach((item) => {
            if(customers[item.cus_phone]) {
              item.cle_name = customers[item.cus_phone].cle_name || ''
            }
          })
        }
      }
      return ret
    }
  },
  inject: ['curCall', 'setCurCall'],
  watch: {
    callList(arr) {
      const index = arr.findIndex(v => v.id === this.newCurCall.id)
      if(index !== -1) {
        const item = arr[index]
        this.setCurCall({
          itemType: this.newCurCall.itemType,
          id: item.id,
          cle_id: item.cle_id,
          cle_name: item.cle_name,
          cle_phone: item.cus_phone,
          call_id: item.call_id,
          call_type: item.call_type
        })
      }
    }
  },
  created() {
    this.reqParam = {
      ag_id: [this.userInfo.userId],
      start_time: dayjs().format('YYYY-MM-DD [00:00:00]'),
      end_time: dayjs().format('YYYY-MM-DD [23:59:59]'),
      page: 0,
      rows: 20,
      size: 20
    }
    this.reqId = getShortId()
    this.getCdrList(false, this.reqId)
    // 监听电话弹屏
    this._Bus.$on("callCommingIn", this.eventHandler);
    // 监听更新客户
    this._Bus.$on("updClient", this.updClient);
  },
  beforeDestroy() {
    this._Bus.$off("callCommingIn", this.eventHandler)
    this._Bus.$off("updClient", this.updClient)
  },
  methods: {
    getCdrList(isRefresh, reqId) {
      if(isRefresh) {
        this.isFinished = false
        this.reqParam.page = 0
        this.reqParam.rows = 20
        this.reqParam.size = 20
        this.callList = []
        this.isRefreshing = true
      }
      if(this.isFinished) return
      this.isLoading = true
      this.reqParam.start_time = dayjs().format('YYYY-MM-DD [00:00:00]')
      this.reqParam.end_time = dayjs().format('YYYY-MM-DD [23:59:59]')
      const { my: { ektv3_page }, } = this._config.URL;
      getCdrList(ektv3_page, { ...this.reqParam, page: this.reqParam.page + 1 }).then(res => {
        if(res.code === 0 && this.reqId === reqId) {
          this.reqParam.page++
          this.callList = [...this.callList, ...res.data.data]
          if(res.data.data.length < 20) {
            this.isFinished = true
          }
          // 获取callRecordCallId
          if(isRefresh) {
            let record = this.callRecords[0]
            if(record) {
              if(record.isCalling) {
                record = this.callRecords[1]
                if(record) {
                  this.callRecordCallId = record.call_id
                }
              } else {
                this.callRecordCallId = record.call_id
              }
            }
          }
        }
      }).finally(() => {
        if(this.reqId === reqId) {
          this.isLoading = false
          this.isRefreshing = false
          if(!this.isInit) {
            this.isInit = true
            this.$nextTick(() => {
              this.selectedCall()
            })
          }
        }
      })
    },
    search(val) {
      this.reqParam.keyword = val
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    refresh() {
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    changeFilter(val) {
      this.reqParam.is_ticket_submitted = val
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    loadMore() {
      this.reqId = getShortId()
      this.getCdrList(false, this.reqId)
    },
    onSwitchClient(item) {
      const index1 = this.callRecords.findIndex((v) => v.id === item.id)
      if(index1 !== -1) {
        const newItem = { ...this.callRecords[index1], ...item }
        this.callRecords.splice(index1, 1, newItem)
        this.$store.dispatch('setCallRecords', [...callRecords])
      }
      const index2 = this.callList.findIndex((v) => v.id === item.id)
      if(index2 !== -1) {
        const newItem = { ...this.callList[index2], ...item }
        this.callList.splice(index2, 1, newItem)
      }
    },
    updClient(clientInfo) {
      const item = {
        id: clientInfo.id,
        cle_id: clientInfo.cle_id,
        cle_name: clientInfo.cle_name,
        cus_phone: clientInfo.cle_phone
      }
      this.onSwitchClient(item)
    },
    selectedCall() {
      if(this.comCallList.length) {
        let item = this.comCallList[0]
        if(this.commingCall) {
          const Obj = this.comCallList.find((v) => v.call_id === this.commingCall.call_id)
          if(Obj) item = obj
          this.commingCall = null
        }
        this.setCurCall({
          itemType: 'todayCall',
          id: item.id,
          cle_id: item.cle_id,
          cle_name: item.cle_name,
          cle_phone: item.cus_phone,
          call_id: item.call_id,
          call_type: item.call_type
        })
      }
    },
    eventHandler(call) {
      this.$emit('tabchange', '1')
      this.commingCall = call
      if(this.comCallList.length) {
        this.commingCall = null
        const item = this.comCallList.find((v) => v.call_id === call.call_id)
        if(item) {
          this.setCurCall({
            itemType: 'todayCall',
            id: item.id,
            cle_id: item.cle_id,
            cle_name: item.cle_name,
            cle_phone: item.cus_phone,
            call_id: item.call_id,
            call_type: item.call_type
          })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.today-call {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .call-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .view-more {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      color: #969799;
      font-size: 14px;
      &-btn {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/todayCall/index.vue